export enum GeniallyAuditEventActionsFilter {
  Creation = 'Creation',
  ConvertedToTeamTemplate = 'ConvertedToTeamTemplate',
  RemovedAsTeamTemplate = 'RemovedAsTeamTemplate',
  RestoredFromBin = 'RestoredFromBin',
  RemovedOfBin = 'RemovedOfBin',
  SendToBin = 'SendToBin',
  Moved = 'Moved',
  MovedToOtherTeam = 'MovedToOtherTeam',
  CopySentToOtherTeam = 'CopySentToOtherTeam',
  CopyAcceptedSentFromOtherTeam = 'CopyAcceptedSentFromOtherTeam',
  Renamed = 'Renamed',
}
